/**
 * Represents a subflow.
 */
export class Subflow {
    static parseJSONstring(json) {
        return JSON.parse(json);
    }
    toJSONstring() {
        return JSON.stringify(this);
    }
}
